module.exports = __webpack_public_path__ + "img/listening_EN.002d0385.png";